document.addEventListener('click', (event) => {
  const button = event.target.closest('[data-precut-scroll]');
  if (!button) return;
  const rail = document.getElementById(button.getAttribute('aria-controls'));
  rail?.scrollBy({ left: rail.clientWidth * Number(button.dataset.precutScroll), behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
});
// Preserve the alternate template and the current filter/sort state in app pagination.
const precutGrid = document.querySelector('.precut-products');
if (precutGrid) {
  const retainPaginationState = () => {
    const current = new URL(location.href);
    if (!current.searchParams.has('view')) return;
    precutGrid.querySelectorAll('nav[aria-label="Pagination"] a[href]').forEach((link) => {
      const destination = new URL(link.href, location.href);
      if (destination.origin !== current.origin || destination.pathname !== current.pathname) return;
      const next = new URL(current.href);
      next.hash = '';
      const page = destination.searchParams.get('page');
      if (page) next.searchParams.set('page', page);
      else next.searchParams.delete('page');
      if (link.href !== next.href) link.href = next.href;
    });
  };
  retainPaginationState();
  new MutationObserver(retainPaginationState).observe(precutGrid, { childList: true, subtree: true, attributes: true, attributeFilter: ['href'] });
}

function bindPrecutCarousels() {
  document.querySelectorAll('.precut-tiles--designer').forEach((rail) => {
    if (rail.dataset.precutBound) return;
    rail.dataset.precutBound = 'true';
    const dots = rail.parentElement.querySelector('[data-precut-dots]');
    if (!dots) return;
    const update = () => {
      const max = rail.scrollWidth - rail.clientWidth;
      const active = max > 0 ? Math.round(rail.scrollLeft / max * (dots.children.length - 1)) : 0;
      [...dots.children].forEach((dot, index) => {
        dot.className = index === active ? 'h-[8px] w-[24px] rounded-full bg-themeGreen' : 'size-[8px] rounded-full bg-backgroundGreen-four';
      });
    };
    rail.addEventListener('scroll', update, { passive: true });
    update();
  });
}
bindPrecutCarousels();
document.addEventListener('shopify:section:load', bindPrecutCarousels);
